import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminUsersEventKeys = {
  ADMIN_USER_APPROVE_ATTEMPT: "admin-user-approve-attempt",
  ADMIN_USER_APPROVE_FAILURE: "admin-user-approve-failure",
  ADMIN_USER_APPROVE_SUCCESS: "admin-user-approve-success",
  ADMIN_USER_DELETE_BUTTON_CLICK: "admin-user-delete-button-click",
  ADMIN_USER_DELETE_FAILURE: "admin-user-delete-failure",
  ADMIN_USER_EDIT_BUTTON_CLICK: "admin-user-edit-button-click",
  ADMIN_USER_EDIT_FORM_SUBMIT_ATTEMPT: "admin-user-edit-form-submit-attempt",
  ADMIN_USER_EDIT_FORM_SUBMIT_FAILURE: "admin-user-edit-form-submit-failure",
  ADMIN_USER_EDIT_FORM_SUBMIT_SUCCESS: "admin-user-edit-form-submit-success",
  ADMIN_USER_EDIT_PAGE_VIEW: "admin-user-edit-page-view",
  ADMIN_USER_EXPORT_CSV_CLICK: "admin-user-export-csv-click",
  ADMIN_USER_EXPORT_CSV_FAILURE: "admin-user-export-csv-failure",
  ADMIN_USER_EXPORT_CSV_SUCCESS: "admin-user-export-csv-success",
  ADMIN_USER_INVITE_BUTTON_CLICK: "admin-user-invite-button-click",
  ADMIN_USER_INVITE_FORM_SUBMIT_ATTEMPT:
    "admin-user-invite-form-submit-attempt",
  ADMIN_USER_INVITE_FORM_SUBMIT_FAILURE:
    "admin-user-invite-form-submit-failure",
  ADMIN_USER_INVITE_FORM_SUBMIT_SUCCESS:
    "admin-user-invite-form-submit-success",
  ADMIN_USER_INVITE_PAGE_VIEW: "admin-user-invite-page-view",
  ADMIN_USER_PROFILE_FORM_SUBMIT_ATTEMPT:
    "admin-user-profile-form-submit-attempt",
  ADMIN_USER_PROFILE_FORM_SUBMIT_FAILURE:
    "admin-user-profile-form-submit-failure",

  ADMIN_USER_PROFILE_FORM_SUBMIT_SUCCESS:
    "admin-user-profile-form-submit-success",
  ADMIN_USER_PROFILE_PAGE_VIEW: "admin-user-profile-page-view",
  ADMIN_USER_REJECT_ATTEMPT: "admin-user-reject-attempt",
  ADMIN_USER_REJECT_FAILURE: "admin-user-reject-failure",
  ADMIN_USER_REJECT_SUCCESS: "admin-user-reject-success",
  ADMIN_USER_RESEND_VERIFICATION_FAILURE:
    "admin-user-resend-verification-failure",
  ADMIN_USER_STATUS_TOGGLE_ATTEMPT: "admin-user-status-toggle-attempt",

  ADMIN_USER_STATUS_TOGGLE_FAILURE: "admin-user-status-toggle-failure",
  ADMIN_USER_STATUS_TOGGLE_SUCCESS: "admin-user-status-toggle-success",
  ADMIN_USER_TABLE_FILTER_AREAS: "admin-user-filter-areas",
  ADMIN_USER_TABLE_FILTER_ROLE: "admin-user-filter-role",
  ADMIN_USER_TABLE_FILTER_STATUS: "admin-user-filter-status",
  ADMIN_USER_TABLE_SEARCH: "admin-user-search",
  ADMIN_USER_VIEW_BUTTON_CLICK: "admin-user-view-button-click",
  ADMIN_USERS_PAGE_VIEW: "admin-users-page-view",
} as const;

export const AdminUsersEventCatalog: EventCatalogFromKeys<
  typeof AdminUsersEventKeys
> = {
  [AdminUsersEventKeys.ADMIN_USER_APPROVE_ATTEMPT]: {
    description: "Admin attempted to approve a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_APPROVE_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_APPROVE_FAILURE]: {
    description: "Admin failed to approve a user",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_APPROVE_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_APPROVE_SUCCESS]: {
    description: "Admin successfully approved a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_APPROVE_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_DELETE_BUTTON_CLICK]: {
    description: "Admin clicked the delete button for a user",
    eventType: EventType.BUTTON_CLICK,
    id: AdminUsersEventKeys.ADMIN_USER_DELETE_BUTTON_CLICK,
  },
  [AdminUsersEventKeys.ADMIN_USER_DELETE_FAILURE]: {
    description: "Admin failed to delete a user",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_DELETE_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_RESEND_VERIFICATION_FAILURE]: {
    description: "Admin failed to resend verification email for a user",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_RESEND_VERIFICATION_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_EDIT_BUTTON_CLICK]: {
    description: "Admin clicked the edit button for a user",
    eventType: EventType.BUTTON_CLICK,
    id: AdminUsersEventKeys.ADMIN_USER_EDIT_BUTTON_CLICK,
  },
  [AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_AREAS]: {
    description: "Admin filtered users by area",
    eventType: EventType.TABLE_FILTER,
    id: AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_AREAS,
  },
  [AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_ROLE]: {
    description: "Admin filtered users by role",
    eventType: EventType.TABLE_FILTER,
    id: AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_ROLE,
  },
  [AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_STATUS]: {
    description: "Admin filtered users by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminUsersEventKeys.ADMIN_USER_TABLE_FILTER_STATUS,
  },
  [AdminUsersEventKeys.ADMIN_USER_INVITE_BUTTON_CLICK]: {
    description: "Admin clicked the invite user button",
    eventType: EventType.BUTTON_CLICK,
    id: AdminUsersEventKeys.ADMIN_USER_INVITE_BUTTON_CLICK,
  },
  [AdminUsersEventKeys.ADMIN_USER_REJECT_ATTEMPT]: {
    description: "Admin attempted to reject a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_REJECT_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_REJECT_FAILURE]: {
    description: "Admin failed to reject a user",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_REJECT_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_REJECT_SUCCESS]: {
    description: "Admin successfully rejected a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_REJECT_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_TABLE_SEARCH]: {
    description: "Admin searched for a specific user",
    eventType: EventType.FILTER,
    id: AdminUsersEventKeys.ADMIN_USER_TABLE_SEARCH,
  },
  [AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_ATTEMPT]: {
    description: "Admin attempted to toggle the status of a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_FAILURE]: {
    description: "Admin failed to toggle the status of a user",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_SUCCESS]: {
    description: "Admin successfully toggled the status of a user",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_STATUS_TOGGLE_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_VIEW_BUTTON_CLICK]: {
    description: "Admin clicked the view button for a user",
    eventType: EventType.BUTTON_CLICK,
    id: AdminUsersEventKeys.ADMIN_USER_VIEW_BUTTON_CLICK,
  },
  [AdminUsersEventKeys.ADMIN_USERS_PAGE_VIEW]: {
    description: "Admin viewed the users management page",
    eventType: EventType.PAGE_VIEW,
    id: AdminUsersEventKeys.ADMIN_USERS_PAGE_VIEW,
  },
  [AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the user edit form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the user edit form",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the user edit form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminUsersEventKeys.ADMIN_USER_EDIT_FORM_SUBMIT_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the user invite form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the user invite form",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the user invite form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminUsersEventKeys.ADMIN_USER_INVITE_FORM_SUBMIT_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_INVITE_PAGE_VIEW]: {
    description: "Admin viewed the user invite page",
    eventType: EventType.PAGE_VIEW,
    id: AdminUsersEventKeys.ADMIN_USER_INVITE_PAGE_VIEW,
  },
  [AdminUsersEventKeys.ADMIN_USER_EDIT_PAGE_VIEW]: {
    description: "Admin viewed the user edit page",
    eventType: EventType.PAGE_VIEW,
    id: AdminUsersEventKeys.ADMIN_USER_EDIT_PAGE_VIEW,
  },
  [AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_CLICK]: {
    description: "Admin clicked export CSV for users",
    eventType: EventType.BUTTON_CLICK,
    id: AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_CLICK,
  },
  [AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_SUCCESS]: {
    description: "Users CSV export completed successfully",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_SUCCESS,
  },
  [AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_FAILURE]: {
    description: "Users CSV export failed",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_EXPORT_CSV_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_PROFILE_PAGE_VIEW]: {
    description: "Admin viewed user profile page",
    eventType: EventType.PAGE_VIEW,
    id: AdminUsersEventKeys.ADMIN_USER_PROFILE_PAGE_VIEW,
  },
  [AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit user profile form",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_ATTEMPT,
  },
  [AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_FAILURE]: {
    description: "Admin user profile form submission failed",
    eventType: EventType.ERROR,
    id: AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_FAILURE,
  },
  [AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_SUCCESS]: {
    description: "Admin user profile form submission succeeded",
    eventType: EventType.INTERACTION,
    id: AdminUsersEventKeys.ADMIN_USER_PROFILE_FORM_SUBMIT_SUCCESS,
  },
};
